<template>
	<div class="page">
		<h1>{{obj.title}}</h1>
		<p class="date">{{obj.times}}</p>
		<div v-html="obj.content"></div>
	</div>
</template>

<script>
	export default {
	   name: '',
	   data() {
			return {
				obj: {},
			}
		},
		methods: {
			
		},
		mounted() {
			let parentid = this.$route.query.id
			let url =
			  this.HOST + 'wzContent/info?id=' + parentid
			this.$axios.get(url).then((res) => {
				this.obj = res.data.content
			})
		}
	}
</script>

<style lang="scss" scoped>
	.page{
		width: 1000px;
		margin: 30px auto;
		text-align: left;
		.date {
			margin-bottom: 20px;
		}
	}
</style>